import React, { Component } from 'react';
import {
	CarouselIndicators,
	CarouselItem,
	Carousel as RS_Carousel,
	Col,
	Container,
	Row,
	Button,
} from 'reactstrap';
import cardimg from '../assets/imgs/Rectangle 4.png';
import WOW from 'wowjs';
import featurbanner from '../assets/imgs/Rectangle 8.png';
import colimg1 from '../assets/imgs/Rectangle 64.png';
import colimg2 from '../assets/imgs/Rectangle 66.png';
import { Route, Switch } from 'react-router';
import Faq from './Faq';

class Features extends Component {
	state = {
		activeIndex: 0,
		activeCarouselIndex: 0,
		animating: false,
		activeTab: '1',
		activeItemIndex: 0,
		animating: false,
	};
	componentDidMount() {
		new WOW.WOW({
			live: false,
		}).init();
	}
	responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 4,
			slidesToSlide: 3, // optional, default to 1.
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 2,
			slidesToSlide: 2, // optional, default to 1.
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
		},
	};
	setAnimating = val => {
		this.setState({ animating: val });
	};
	chevronWidth = 40;
	items = [0, 1, 2, 3, 4];
	next = () => {
		if (this.state.animating) return;
		const nextIndex =
			this.state.activeIndex == this.items.length - 1
				? 0
				: this.state.activeIndex + 1;
		this.setState({ activeIndex: nextIndex });
	};
	prev = () => {
		if (this.state.animating) return;
		const nextIndex =
			this.state.activeIndex == 0
				? this.items.length - 1
				: this.state.activeIndex - 1;
		this.setState({ activeIndex: nextIndex });
	};
	goToIndex = newIndex => {
		if (this.state.animating) return;
		this.setState({ activeIndex: newIndex });
	};
	slides = this.items.map(item => {
		return (
			<>
				{/* <CarouselItem
        onExiting={() => this.setState({ animating: true })}
        onExited={() => this.setState({ animating: false })}
      >
        <div
          style={{
            minHeight: "100vh",
            background: `url(${Banner})`,
            backgroundSize: "cover",
          }}
          className="d-flex"
        >
          <div className="c-i d-flex flex-column justify-content-center d-md-block">
            <h1 className="d-none d-md-block">Where memories keep living.</h1>
            <h2 className="d-none d-md-block">
              A private, safe and beautiful space to capture your story. For now
              and for future generations. Share with others or keep to yourself,
              with simple and easy to use privacy tools.
            </h2>
            <h2 className="d-block d-md-none">Where memories keep living.</h2>
            <h5 className="d-block d-md-none">
              A private, safe and beautiful space to capture your story. For now
              and for future generations. Share with others or keep to yourself,
              with simple and easy to use privacy tools.
            </h5>
            <div className="d-flex">
              <Button className="mr-2">Start Now</Button>
              <Button>Watch Our Videos</Button>
            </div>
          </div>
        </div>
      </CarouselItem>
     */}
			</>
		);
	});
	toggle = id => {
		this.setState({ activeTab: id });
	};
	setActiveIndex(idx) {
		this.setState({
			activeCarouselIndex: idx,
		});
	}
	next = () => {
		if (this.state.animating) return;
		const nextIndex =
			this.state.activeCarouselIndex === new Array(5).fill(1).length - 1
				? 0
				: this.state.activeCarouselIndex + 1;
		this.setActiveIndex(nextIndex);
	};

	previous = () => {
		if (this.state.animating) return;
		const nextIndex =
			this.state.activeCarouselIndex === 0
				? new Array(5).fill(1).length - 1
				: this.state.activeCarouselIndex - 1;
		this.setActiveIndex(nextIndex);
	};

	goToIndex = newIndex => {
		if (this.state.animating) return;
		this.setActiveIndex(newIndex);
	};
	render() {
		return (
			<>
				<Switch>
					<Route path='/main/faq' exact component={Faq} />
				</Switch>
				<div id='our-features' className='section-start mb-0'>
					<div className='features-p'>
						<Container className='px-0'>
							<div className='section-titleF'>
								<h1
									className='mb-0 text-uppercase'
									style={{
										fontFamily: 'Ogg',
										letterSpacing: 6,
										wordSpacing: 8,
									}}
								>
									Memora suggests
								</h1>
								<small className='text-dark font-weight-semibold text-left'>
									Main / Features
								</small>
							</div>
							<RS_Carousel
								activeIndex={this.state.activeCarouselIndex}
								next={this.next}
								previous={this.previous}
							>
								<CarouselIndicators
									items={new Array(5).fill(1)}
									activeIndex={this.state.activeCarouselIndex}
									onClickHandler={this.goToIndex}
									className='c-i-f'
								/>
								{new Array(5).fill(1).map(() => (
									<CarouselItem
										onExiting={() =>
											this.setAnimating(true)
										}
										onExited={() =>
											this.setAnimating(false)
										}
									>
										<div className='feature'>
											<Row noGutters>
												<Col sm='5'>
													<img
														src={cardimg}
														className='w-100 h-100'
														style={{
															objectFit: 'cover',
														}}
													/>
												</Col>
												<Col sm='7'>
													<div className='pt-1 pl-4 text-left h-100 d-flex'>
														<div>
															<h1 className='font-weight-bold text-uppercase'>
																Pet Memora
															</h1>
															<h5 className='mt-4 c-text'>
																Lorem ipsum
																dolor sit amet,
																consectetur
																adipiscing elit,
																sed do eiusmod
																tempor
																incididunt ut
																labore et dolore
																magna aliqua. Ut
																enim ad minim
																veniam, quis
																nostrud
																exercitation
																ullamco laboris
																nisi ut aliquip
																ex ea commodo
																consequat.
															</h5>
															<Button
																className='btn-outline px-4 mt-5 landing-btn'
																href='/main/faq'
															>
																Contact Us
															</Button>
														</div>
													</div>
												</Col>
											</Row>
										</div>
									</CarouselItem>
								))}
							</RS_Carousel>

							<div
								className='section-titleF mb-0'
								style={{ margin: '130px 0 60px' }}
							>
								<h1
									className='mb-0 text-uppercase text-center'
									style={{
										fontFamily: 'Ogg',
										letterSpacing: 6,
										wordSpacing: 8,
									}}
								>
									corporate / institutions proposal
								</h1>
							</div>
						</Container>
						<div
							className='feature-banner'
							style={{
								backgroundImage: `url('${featurbanner}')`,
							}}
						></div>
						{/* <Container> */}
						<Row sm='2' xs='1' className='row2'>
							<Col sm='6' xs='12' className='p-0'>
								<div className='mt-0 mb-0 text-left d-flex align-items-center bg-white feature-box'>
									<div>
										<h2 className='font-weight-bold text-uppercase'>
											Memora for the exhibitions
										</h2>
										<p
											className='mt-4'
											style={{ lineHeight: '1.8' }}
										>
											Lorem ipsum dolor sit amet,
											consectetur adipiscing elit, sed do
											eiusmod tempor incididunt ut labore
											et dolore magna aliqua. Ut enim ad
											minim veniam, quis nostrud
											exercitation ullamco laboris nisi ut
											aliquip ex ea commodo consequat.
										</p>
										<Button className='btn-outline px-lg-5 px-md-4 mt-4 landing-btn'>
											More
										</Button>
									</div>
								</div>
							</Col>
							<Col sm='6' xs='0'></Col>
						</Row>

						<Row sm='2' xs='1'>
							<Col sm='6' xs='12' className='p-0'>
								<img src={colimg1} width='100%' />
							</Col>
							<Col sm='6' xs='12' className='p-0'>
								<div
									className='text-left d-flex align-items-center bg-white feature-boxr'
									// style={{
									//   border: "1px solid #000000",
									//   padding: "70px",
									//   marginRight: "299px",
									//   marginTop:"50px",
									//   marginBottom:"60px"
									// }}
								>
									<div>
										<h2 className='font-weight-bold text-uppercase'>
											Memora for the exhibitions
										</h2>
										<p
											className='mt-4'
											style={{ lineHeight: '1.8' }}
										>
											Lorem ipsum dolor sit amet,
											consectetur adipiscing elit, sed do
											eiusmod tempor incididunt ut labore
											et dolore magna aliqua. Ut enim ad
											minim veniam, quis nostrud
											exercitation ullamco laboris nisi ut
											aliquip ex ea commodo consequat.
										</p>
										<Button className='btn-outline px-lg-5 px-md-4 mt-4 landing-btn'>
											More
										</Button>
									</div>
								</div>
							</Col>
						</Row>

						<Row sm='2' xs='1' style={{ marginTop: '-50px' }}>
							<Col sm='6' xs='12' className='pr-0 pl-4'>
								<div
									className='text-left d-flex align-items-center bg-white  feature-box'
									// style={{
									//   border: "1px solid #000000",
									//   padding: "70px",
									//   marginLeft: "299px",
									//   marginTop:"50px",
									//   marginBottom:"120px"
									// }}
								>
									<div>
										<h2 className='font-weight-bold text-uppercase'>
											Memora for the exhibitions
										</h2>
										<p
											className='mt-4'
											style={{ lineHeight: '1.8' }}
										>
											Lorem ipsum dolor sit amet,
											consectetur adipiscing elit, sed do
											eiusmod tempor incididunt ut labore
											et dolore magna aliqua. Ut enim ad
											minim veniam, quis nostrud
											exercitation ullamco laboris nisi ut
											aliquip ex ea commodo consequat.
										</p>
										<Button className='btn-outline px-lg-5 px-md-4 mt-4 landing-btn'>
											More
										</Button>
									</div>
								</div>
							</Col>
							<Col sm='6' xs='12' className='p-0'>
								<img src={colimg2} width='100%' />
							</Col>
						</Row>
						{/* </Container> */}
					</div>
				</div>
			</>
		);
	}
}

export default Features;
